import { render, staticRenderFns } from "./manage-sso-mapping.vue?vue&type=template&id=7c3d1d21&scoped=true"
import script from "./manage-sso-mapping.vue?vue&type=script&lang=js"
export * from "./manage-sso-mapping.vue?vue&type=script&lang=js"
import style0 from "./manage-sso-mapping.vue?vue&type=style&index=0&id=7c3d1d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d1d21",
  null
  
)

export default component.exports